import { render, staticRenderFns } from "./TemplateInspectionGroup.vue?vue&type=template&id=c55297fa&scoped=true"
import script from "./TemplateInspectionGroup.vue?vue&type=script&lang=ts"
export * from "./TemplateInspectionGroup.vue?vue&type=script&lang=ts"
import style0 from "./TemplateInspectionGroup.vue?vue&type=style&index=0&id=c55297fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c55297fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
